export const SEARCH_CUSTOMER_COLUMNS: Array<string> = [
  'customer_table_c1_name',
  'customer_table_c2_email',
  'customer_table_c3_org_id',
  'customer_table_c4_org_name',
  'customer_table_c5_role',
  'customer_table_c6_type'
]
